var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"download btn primary",attrs:{"href":_vm.downloadLink._attributes.href,"download":"","title":_vm.downloadLink._attributes.title}},[_vm._v("Download")])}
var staticRenderFns = []

export { render, staticRenderFns }